<template>
  <div @click="onTrack">
    <slot />
  </div>
</template>

<script>
import commonMixins from '../mixins';

export default {
  name: 'SensorTrack',
  mixins: [commonMixins],
  props: {
    datas: {
      type: [Array, Object],
      default: () => {
        return {};
      },
    },
  },
  methods: {
    onTrack() {
      if (Array.isArray(this.datas)) {
        this.datas.forEach((data) => {
          const cdata = { ...data };
          if (!cdata.current_page) {
            cdata.current_page = location.href;
          }
          const { sensorEventName, disable, ...rest } = cdata;
          if (sensorEventName && !disable) {
            this.$$track(sensorEventName, { ...rest });
          }
        });
      }

      if (Object.prototype.toString.call(this.datas) === '[object Object]') {
        const cdata = { ...this.datas };
        if (!cdata.current_page) {
          cdata.current_page = location.href;
        }
        const { sensorEventName, disable, ...rest } = cdata;
        if (sensorEventName && !disable) {
          this.$$track(sensorEventName, { ...rest });
        }
      }
    },
  },
};
</script>
